const ROLE_DISPLAY_NAMES: Readonly<Record<string, string>> = {
  Data_Manager: 'IDM',
  DATA_MANAGER: 'IDM',
  'Data Manager': 'IDM',
  Audit_Manager: 'Auditor',
  AUDIT_MANAGER: 'Auditor',
  'Audit Manager': 'Auditor',
  Site_User: 'Site Coordinator',
  SITE_COORDINATOR: 'Site Coordinator',
  Primary_Reader: 'Reader',
  PRIMARY_READER: 'Reader',
  'Primary Reader': 'Reader',
}

export const getRoleDisplayName = (roleName: string): string => ROLE_DISPLAY_NAMES[roleName] ?? roleName
